uniform vec2 resolution;
uniform float devicePixelRatio;
uniform float time;
varying vec2 vUv;

#pragma glslify: rotate2DMatrix3 = require(../../shaders/rotate-2D-matrix3)
#pragma glslify: scale2DMatrix3 = require(../../shaders/scale-2D-matrix3)
#pragma glslify: translate2DMatrix3 = require(../../shaders/translate-2D-matrix3)
#pragma glslify: transform2DMatrix3 = require(../../shaders/transform-2D-matrix3)

#pragma glslify: Perlin3D_Deriv = require(../../shaders/wombat/Perlin3D_Deriv)

#pragma glslify: oklabToLinearSRGB = require(../../shaders/oklab-to-linear-srgb)
#pragma glslify: oklchToOklab = require(../../shaders/oklch-to-oklab)


float sdCircle( vec2 p, float r )
{
    return length(p) - r;
}

float angleFromOrigin(vec2 point) {
    return atan(point.y, point.x); // Calculate the angle in radians
}

vec3 layer(in vec3 p, in vec3 color, in mat3 translation, float t) {
    vec3 transformedP = inverse(translation) * p;
    float shapeDist = sdCircle(transformedP.xy, 10.0);
    float smoothing = fwidth(shapeDist);
    // float smoothing = 1.0;
    float isShape = smoothstep(0.0+smoothing, 0.0, shapeDist);
    float angle = angleFromOrigin(transformedP.xy);
    vec3 layerColor = vec3(0.8 + 0.4 * cos(t*0.5), 0.3, angle * 1.0);
    return mix(color, layerColor, clamp(isShape, 0.0, 1.0));
}



void main() {
    // vec2 st = gl_FragCoord.xy / resolution.xy / devicePixelRatio;
    // gl_FragColor = vec4(st.x, st.y, 1.0, 1.0);

    vec3 p = vec3((vUv - vec2(0.5)) * (resolution.xy / devicePixelRatio), 1.0);

    vec3 colorOkLch = vec3(0.0);

    // Lazy doing this here:
    

    int count = 32;

    for (int idx = 0; idx < count; idx++) {

        float scalar = (float(count-idx)/float(count));
        float timeStep = 3.0 * scalar;
        float t = (time * 0.001) - timeStep;
        vec4 noise = Perlin3D_Deriv(vec3(0.0, t, 0.0));

        float scale = 0.25 + 50.0 * scalar;
        scale *= scalar;
        scale += 0.3;

        float movement = 50.0;

        mat3 transform = transform2DMatrix3(
            noise.x * movement, noise.y * movement, 
            noise.z * 3.141, 
            scale, scale
        );

        colorOkLch = layer(p, colorOkLch, transform, t);
    }

    vec3 rgb = clamp(oklabToLinearSRGB(oklchToOklab(colorOkLch)), vec3(0.0), vec3(1.0));
    gl_FragColor = vec4(rgb, 1.0);
}